import { UserIcon, ViewColumnsIcon } from "@heroicons/react/20/solid";
import React from "react";
import { connect } from "react-redux";
import { Actions as INTEGRATION_ACTIONS } from "../../store/actions/integrationActions";

const UserConnectedButton = ({ integration, openUserConnectedOrgsModal, connectAdvisor, connectUser }) => {
	if (!connectAdvisor && !connectUser) return null;

	if (connectAdvisor && integration) {
		return (
			<button
				className="btn btn-default"
				onClick={() => {
					openUserConnectedOrgsModal(integration);
				}}
			>
				<ViewColumnsIcon className="align-middle mr-2 w-8 h-8" />
				Advisor Connected
			</button>
		);
	}

	if (connectUser && integration) {
		return (
			<button
				className="btn btn-default"
				onClick={() => {
					openUserConnectedOrgsModal(integration);
				}}
			>
				<UserIcon className="align-middle mr-2 w-8 h-8" />
				User Connected
			</button>
		);
	}

	if (connectAdvisor) {
		return (
			<button
				className={`btn btn-${integration ? "default" : "primary"}`}
				onClick={() => {
					connectAdvisor();
				}}
			>
				<ViewColumnsIcon className="align-middle mr-2 w-8 h-8" />
				Connect Advisor
			</button>
		);
	}

	if (connectUser)
		return (
			<button
				className={`btn btn-${integration ? "default" : "primary"}`}
				onClick={() => {
					connectUser();
				}}
			>
				<UserIcon className="align-middle mr-2 w-8 h-8" />
				Connect User
			</button>
		);

	return null;
};

const mapStateToProps = (state, ownProps) => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({
	openUserConnectedOrgsModal: (object) => dispatch(INTEGRATION_ACTIONS.openUserConnectedOrgsModal(object)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserConnectedButton);
